import { Box, Paper, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import type { ReactNode } from 'react';

interface SectionHeaderProps {
  children: ReactNode;
  action?: ReactNode;
  error?: boolean;
}

export function SectionHeader({ children, action, error }: SectionHeaderProps) {
  return (
    <Paper
      sx={{
        bgcolor: error ? 'error.main' : 'custom.darkTeal',
        color: 'common.white',
        p: 2,
        mb: 0,
        borderRadius: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography component="h2" sx={{ typography: { xs: 'h6', md: 'h5' } }}>
          {children}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {error && <ErrorIcon sx={{ fontSize: 32 }} />}
          {action}
        </Box>
      </Box>
    </Paper>
  );
}

export default SectionHeader;
 